export default __webpack_public_path__ + "static/029-55be462af7c4055230c7575b6883f105.jpg";